module.exports = __webpack_public_path__ + "static/media/nigori.12e91169.png";